<div class="card py-4 px-3 md:px-6 overflow-auto">
  <div class="flex flex-column align-items-start md:flex-row md:align-items-center md:justify-content-between border-bottom-1 surface-border pb-5 min-w-max">
    <div class="flex flex-column">
      <img id="invoice-logo" [src]="'assets/images/Logo/chemcolor-logo.png'" class="mb-2" alt="chemcolor"
           height="50px"
           width="208px"/>
      <div *ngIf="this.deliveryNote.seller?.address !== null">{{this.deliveryNote.seller.address.street1}}</div>
      <div
        *ngIf="this.deliveryNote.seller?.address !== null">{{this.deliveryNote.seller.address.postalCode}} {{this.deliveryNote.seller.address.postal}}
        , {{this.deliveryNote.seller.address.country.name}}</div>
      <div>VAT: {{this.deliveryNote.seller.vat}}</div>
    </div>
    <div class="flex flex-column mt-5 md:mt-0">
      <div class="text-xl font-semibold text-left md:text-right mb-2 text-uppercase" translate>
        DELIVERY_NOTE.DELIVERY_NOTE<span>: {{this.deliveryNote.number}}</span></div>
      <div class="flex flex-column">
        <div class="flex justify-content-between align-items-center mb-1">
          <span class="font-semibold mr-6" translate>OFFER.DATE</span>
          <span>{{this.deliveryNote.dateCreated|date:'dd MMM yyyy'}}</span>
        </div>
        <div class="flex justify-content-between align-items-center mb-1">
          <span class="font-semibold mr-6" translate>OFFER.VALID_UNTIL</span>
          <span>{{this.deliveryNote.dateValid|date:'dd MMM yyyy'}}</span>
        </div>
        <div class="flex justify-content-between align-items-center mb-1">
          <span class="font-semibold mr-6" translate>OFFER.DELIVERY</span>
          <span translate><span>{{this.deliveryNote.daysToDelivery}} </span>OFFER.DAYS_FROM_OFFER_CONFIRMATION</span>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-5 mb-8 flex flex-column">
    <div class="mb-2 text-2xl font-medium">{{this.deliveryNote.buyer?.name}}</div>
    <div *ngIf="this.deliveryNote.buyer?.address !== null">{{this.deliveryNote.buyer?.address?.street1}}</div>
    <div
      *ngIf="this.deliveryNote.buyer?.address !== null">{{this.deliveryNote.buyer?.address?.postalCode}} {{this.deliveryNote.buyer?.address?.postal}}
      , {{this.deliveryNote.buyer?.address?.country.name}}</div>
    <div>VAT: {{this.deliveryNote.buyer?.vat}}</div>
  </div>

  <div class="invoice-items" [ngStyle]="{'min-height': showDiscounts ? '170px' : '255px'}">
    <p-table [value]="this.deliveryNote.deliveryNotesArticles" dataKey="id">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 48%" translate>OFFER.NAME</th>
          <th style="width:4rem; text-align: right" translate>OFFER.EAN</th>
          <th style="width:4rem; text-align: right" translate>OFFER.QUANTITY</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-offerArticle>
        <tr>
          <td>{{offerArticle.article.nameLong}}</td>
          <td style="text-align: right">{{offerArticle.article.ean}}</td>
          <td style="text-align: right">{{offerArticle.quantity}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="flex flex-column md:flex-row md:align-items-start md:justify-content-between mt-8">
    <div class="font-semibold mb-3 md:mb-0">
      <b translate>OFFER.NOTES</b>
      <div>{{deliveryNote.remarks}}</div>
      <br>
      <b translate>OFFER.RECEIVER</b>
      <div class="bill-to">{{this.deliveryNote.receiver?.name}}</div>
      <div class="invoice-to-info">
        <div *ngIf="this.deliveryNote.receiver?.address !== null">{{this.deliveryNote.receiver?.address?.street1}}</div>
        <div *ngIf="this.deliveryNote.receiver?.address !== null">{{this.deliveryNote.receiver?.address?.postalCode}} {{this.deliveryNote.receiver?.address?.postal}}
          , {{this.deliveryNote.receiver?.address?.country?.name}}</div>
        <div>VAT: {{this.deliveryNote.receiver.vat}}</div>
      </div>
    </div>
  </div>
  <div class="mt-8">
    <small>Družba Chemcolor Sevnica d.o.o. ima z družbo Slopak d.o.o. sklenjeno pogodbo št. 300/26-17
      skladno
      s 26. in 34. členom Uredbe o ravnanju z embalažo in odpadno embalažo. Za zamudo pri plačilu si
      pridržujemo pravico zaračuna pogodbene oziroma zakonite zamudne obres. Pridržujemo si lastninsko
      pravico
      za prodano blago do poravnave celotne vrednos terjatev. V primeru predčasnega plačila priznavamo
      sconto
      0,06 dnevno, pod pogojem, da so poravnane vse zapadle obveznos. Reklamacije upoštevamo najkasneje 8
      dni
      po prejemu blaga. V primeru spora je pristojno Okrožno sodišče v Krškem.</small>
  </div>
  <div class="flex flex-column md:flex-row md:align-items-start md:justify-content-between mt-1" style="text-align: justify;">
    <div class="">
      <img src="assets/images/SIQ.png" alt="SIQ" width="80px" class="siq">
    </div>
    <div>
      <div class="flex flex-column md:flex-row md:align-items-start md:justify-content-between">
        <div>
          <small><b>Banka Intesa Sanpaolo d.d.<br/>
            IBAN: SI56 1010 0005 5221 222 SWIFT: BAKOSI2X</b></small>
        </div>
        <div>
          <small><b>Nova Ljubljanska Banka d.d.<br/>
            IBAN: SI56 0237 9001 3890 812 SWIFT: LJBASI2X</b></small>
        </div>

      </div>
      <div>
        <small>ID za DDV: SI24218359 • Matična številka: 5309115 • Registrirano pri Okrožnem sodišču v
          Novem
          mestu •
          Številka vložka: 1/392/00 • Osnovni kapital: 106.826,90 EUR</small>
      </div>
    </div>
  </div>
</div>

